<template>
  <div>
    <h3>{{name}}</h3>
    <div class="row">
      <div class="col" v-if="canEdit">
        <under-input v-model="item.name">
          Name
        </under-input>
      </div>
      <div class="col">
        <under-input v-model="item.detail">
          ( Detail )
        </under-input>
      </div>
      <div class="col-3 text-center" v-if="canEdit && ['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)">
        <pf-actions v-model="item.actions">Actions</pf-actions>
      </div>
    </div>
    
    <under-input v-if="canEdit" v-model="item.summary" maxlength="255">
      Summary
    </under-input>
    <under-text-area-md v-if="canEdit" v-model="item.description" rows="6">
      Description
    </under-text-area-md>    
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import PfActions from "../shared/_PfActions.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sections-rules-default",
  components: {
    PfActions,
    UnderInput,
    UnderTextAreaMd,
  },
  props: ["section", "item"],
  computed: {
    ...mapGetters({
      charactersCanEdit: "characters/canEdit",
    }),
    ...mapState({
      ruleset: (state) => state.characters.current.ruleset,
    }),
    name() {
      return this.canEdit ? this.item.type : this.item.name;
    },
    canEdit() {
      return this.charactersCanEdit && this.item.stock !== true;
    },
  },
};
</script>
